import { track } from '../analytics/datalayer'

/** Reveals por IntersectionObserver + section_view + scroll_depth.
 *  Independiente del 3D: funciona igual en tier STATIC. */
export function initReveals(): void {
  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add('in')
          io.unobserve(e.target)
        }
      }
    },
    { threshold: 0.18 },
  )
  document.querySelectorAll<HTMLElement>('.reveal').forEach((el, i) => {
    el.style.transitionDelay = `${(i % 4) * 0.07}s`
    io.observe(el)
  })

  const seen = new Set<string>()
  const sections = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        const name = (e.target as HTMLElement).dataset.chamber
        if (e.isIntersecting && name && !seen.has(name)) {
          seen.add(name)
          track({
            event: 'section_view',
            section_name: name,
            section_index: seen.size - 1,
          })
        }
      }
    },
    { threshold: 0.35 },
  )
  document.querySelectorAll('[data-chamber]').forEach((s) => sections.observe(s))

  const fired = new Set<number>()
  const onScroll = () => {
    const max = document.documentElement.scrollHeight - innerHeight
    if (max <= 0) return
    const pct = (scrollY / max) * 100
    for (const mark of [25, 50, 75, 100] as const) {
      if (pct >= mark && !fired.has(mark)) {
        fired.add(mark)
        track({ event: 'scroll_depth', percent: mark })
      }
    }
    if (fired.size === 4) removeEventListener('scroll', onScroll)
  }
  addEventListener('scroll', onScroll, { passive: true })
}
